import { QueryClient } from "@tanstack/react-query";
import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 10, // 10 минут — не запрашивать повторно
      cacheTime: 1000 * 60 * 60, // кэш хранится 1 час
      refetchOnWindowFocus: false,
      retry: 2,
    },
  },
});

// Persist в localStorage
const localStoragePersister = createSyncStoragePersister({
  storage: window.localStorage,
});

// Сохраняем данные в кэш, чтобы при перезагрузке не было повторных запросов
persistQueryClient({
  queryClient,
  persister: localStoragePersister,
});
